import * as React from 'react'

import { Box, type EnhancedDimension } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import DayPicker from 'modules/core/components/Inputs/DayPicker'
import Select from 'modules/core/components/Inputs/Select'
import InputText from 'modules/core/components/Inputs/Text'
import { FilterOption } from 'modules/core/components/MultiFilters/types'
import i18n from 'modules/core/lib/i18n'
import validateNumberInput from 'modules/core/lib/validateNumberInput'

interface Props {
  field: Field
  options: FilterOption
  condition?: string
  width?: EnhancedDimension
}

const InputValue = ({ field, options, condition = '', width = 's140' }: Props) => {
  const isNumberDate = ['last_x_days', 'last_x_weeks', 'last_x_years'].includes(condition)
  const isNumber = options.type === 'number' || isNumberDate
  const isDate = options.type === 'date' && !isNumberDate
  const isString = options.type === 'string'
  const isSelect = options.type === 'single_choice' || options.type === 'equal_choice'
  const isCustom = options.type === 'custom'

  return (
    <Box width={width}>
      {isSelect && (
        <Select
          hideLabel
          field={field}
          options={options.options || []}
          none={i18n.t('filters.filter.none')}
        />
      )}
      {isString && <InputText hideLabel field={field} placeholder={i18n.t('common.search_by')} />}
      {isNumber && <InputText hideLabel field={field} validation={validateNumberInput} />}
      {isDate && <DayPicker field={field} />}
      {isCustom && options.component && options.component({ field })}
    </Box>
  )
}

export default observer(InputValue)
